<cmv-modal-base [isModalOpen]="isModalOpen">
	<section class="tdc-ship-notice">
		<button cmvBtn="icon" (click)="onCloseModal()">
			<i class="bi bi-x"></i>
		</button>

		<h1>
			{{ isCreditCard ? '¡Tu tarjeta de crédito!' : '¡Tu tarjeta de débito!' }}
		</h1>

		<div
			class="tdc-ship-notice__card"
			*ngIf="isCreditCard && (tdcCard$ | async) as tdcCard">
			<img
				[src]="tdcCard.typeId === 1 ? classicTdcPathImg : goldTdcPathImg"
				alt="tarjeta crédito" />
		</div>

		<div class="tdd-ship-notice__card" *ngIf="!isCreditCard">
			<img [src]="debitCardPathImg" alt="tarjeta débito" />
		</div>

		<p>{{ deliveryTimeLabel }}</p>

		<img
			*ngIf="cardWithName && isCreditCard"
			src="./assets/images/tdc/delivery-time.svg"
			alt="icono de tiempo de entrega" />

		<img
			*ngIf="!isCreditCard"
			src="./assets/images/tdc/delivery-time.svg"
			alt="icono de tiempo de entrega" />

		<section
			class="tdc-ship-notice__delivery-address"
			*ngIf="cardWithName && isCreditCard">
			<div class="tdc-ship-notice__delivery-address-title">
				<i class="bi bi-house"></i>
				<span>Dirección de entrega</span>
			</div>

			<p
				class="tdc-ship-notice__delivery-address-details"
				*ngIf="applicantParticularAddress$ | async as applicantAddress">
				{{ applicantAddress | titlecase }}
			</p>
		</section>

		<button cmvBtn="action" (click)="onCloseModal()">OK</button>
	</section>
</cmv-modal-base>
